import { PDFViewer, pdf } from "@react-pdf/renderer";
import { useEffect, useState, FC } from "react";
import useCallApiAndLoad from "../../../../../../hooks/useCallApiAndLoad";
import { getComplianceReport } from "../../../../services/devsServices";
import { getAuthToken, unsetAuth } from "../../../../../../helpers/authHelper";
import { useDispatch, useSelector } from "react-redux";
import { AppStore } from "../../../../../../redux/store";
import { useNavigate, useParams } from "react-router-dom";
import { logoutAction } from "../../../../../../redux/features/auth";
import { fetchResponseAdapter } from "../../../../../../adapters/fetchAdapter";

import { PDFContainerType, ComplianceReportType } from "./type";
import PDFDocument from "./PDFDocument";
import Loading from "./Loading";

const PDFContainer: FC<PDFContainerType> = ({ selectedKycId, setOpen }) => {
    const user = useSelector((store: AppStore) => store.auth);
    const token = getAuthToken(user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { country } = useSelector((store: AppStore) => store.country);
    const createdBy = user.name;

    const { id_unit = "" } = useParams();
    const { callEndpoint } = useCallApiAndLoad();

    const [isLoading, setIsLoading] = useState(false);
    const [complianceReport, setComplianceReport] = useState<ComplianceReportType>({} as ComplianceReportType);

    const getDataComplianceReport = async () => {
        setIsLoading(true);

        try {
            const { status, data } = await callEndpoint(
                getComplianceReport(token, id_unit, selectedKycId as string)
            );
            if (status === 401) {
                dispatch(logoutAction({}));
                unsetAuth();
                navigate(`/app/${country}/auth/desarrolladoras/login`);
            }

            if (status === 200) {
                const response = fetchResponseAdapter(data);
                setComplianceReport(response?.data as ComplianceReportType);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (selectedKycId) {
            getDataComplianceReport();
        }
    }, [selectedKycId]);

    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    useEffect(() => {
        if (
            isMobile &&
            complianceReport &&
            !isLoading &&
            Object.keys(complianceReport).length > 0
        ) {
            const downloadPDF = async () => {
                // Genera el PDF y lo descarga automáticamente en dispositivos móviles
                const blob = await pdf(
                    <PDFDocument complianceReport={complianceReport} createdBy={createdBy} />
                ).toBlob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `lista-de-cautela-${selectedKycId}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

                if (setOpen) setOpen(false); // Cierra el modal después de la descarga
            };
            downloadPDF();
        }
    }, [isMobile, complianceReport, isLoading, createdBy]);

    return (
        <div className="size-full">
            {!!complianceReport && !isLoading ? (
                isMobile ? (
                    <Loading />
                ) : (
                    <PDFViewer width="100%" height={"100%"}>
                        <PDFDocument complianceReport={complianceReport} createdBy={createdBy} />
                    </PDFViewer>
                )
            ) : (
                <Loading />
            )}
        </div>
    );
}

export default PDFContainer;


/* 
    Componente contenedor de la logica del PDF, maneja la obtencion de datos y la logica de descarga en movil

    - Daniel Bonilla Septiembre 2025
*/